/**
 * RequestLogs payload
 */
import { ApiResponse } from '../../../../types';
import { ErrorResponse } from '../../../../types/interface/error.interface';

import { RequestLogsResponse } from 'types/interface/request-logs.interface';

export interface RequestLogsAction<T> {
  payload?: T;
  type: string;
}

export type RequestLogsActionCreator<T = undefined> = (payload?: T) => RequestLogsAction<T>;

/**
 * RequestLogs store state
 */
export interface RequestLogsState {
  loading: boolean;
  error: ErrorResponse;
  response: ApiResponse;
  requestLogs: RequestLogsResponse;
}

/**
 * Name of the RequestLogs Store
 */
export const REQUEST_LOGS_STORE_NAME = 'request-logs';

/**
 * RequestLogs initial state
 */
export const REQUEST_LOGS_INITIAL_STATE: RequestLogsState = {
  response: null,
  requestLogs: {
    meta: {},
    data: [],
  },
  loading: false,
  error: null,
};
